import type { RouteObject } from "react-router-dom";
import PageHome from "./page-home";

export function RouterHome(): RouteObject[] {
  return [{ path: "/home", element: <PageHome /> }];
}
